import React from "react"

const Title = ({ children }) => {
  return (
    <div className="text-center mb-16 w-full text-2xl sm:text-3xl font-bold">
      {children}
    </div>
  )
}

export default Title
